import React, { FC, LegacyRef } from 'react'
import { SetNavElement } from 'Src/hooks/useNav'
import { AccordionComponent, FormNavigationItem, UISizes } from 'LibNeo'
import {
	BgLimitRequestFull,
	bgLimitRequestSelector,
	BgStatus,
	getStatusByType,
	WhiteBlock,
} from 'Pages/ibro'
import { useSelector } from 'react-redux'
import { CompanyInfo } from './CompanyInfo'
import { LeaderInfo } from './LeaderInfo'
import { StartFields } from './StartFields'

interface ComponentProps {
	setNavElement: SetNavElement
	blockItem: Required<FormNavigationItem>
}

export const OrganizationInfo: FC<ComponentProps> = ({ setNavElement, blockItem }) => {
	const item = useSelector(bgLimitRequestSelector.selectCurrentLimitRequest) as BgLimitRequestFull
	const {
		status: { status_slug },
	} = item

	return (
		<div ref={setNavElement(blockItem.idx) as LegacyRef<HTMLDivElement>}>
			<WhiteBlock>
				<AccordionComponent
					id={blockItem.title}
					noExpand
					titleText={blockItem.title}
					status={getStatusByType(blockItem.type)}
					titleSize={UISizes.BIG}
				>
					{status_slug === BgStatus.NOVA ? (
						<StartFields />
					) : (
						<>
							<LeaderInfo />
							<CompanyInfo />
						</>
					)}
				</AccordionComponent>
			</WhiteBlock>
		</div>
	)
}
